import React from 'react';

import classnames from 'clsx';
import { FormattedMessage } from 'react-intl';

import { messages } from './messages';

import style from './plan-tag.module.less';

/**
 * @param {object} props
 * @param {boolean} props.isCurrentPlan
 * @param {boolean} [props.isPromotionalPlan]
 * @param {boolean} props.isRecommendedPlan
 * @param {boolean} props.isSelectedPlan
 * @returns {React.JSX.Element | undefined}
 */
export const PlanTag = ({ isCurrentPlan, isPromotionalPlan, isRecommendedPlan, isSelectedPlan }) => {
  if (isCurrentPlan) {
    return (
      <span className={style['current-tag']}>
        <FormattedMessage {...messages.currentPlan} />
      </span>
    );
  }

  if (isRecommendedPlan) {
    return (
      <span
        className={classnames(style['recommended-tag'], {
          [style['is-selected']]: isSelectedPlan,
        })}
      >
        <FormattedMessage {...messages.recommendedPlan} />
      </span>
    );
  }

  if (isPromotionalPlan) {
    return (
      <span className={classnames(style['promotional-tag'])}>
        <FormattedMessage {...messages.recommendedPlan} />
      </span>
    );
  }
};
